import { defineMessages } from 'react-intl'

export default defineMessages({
  weeks: {
    id: 'Kickstarter.weeks',
    defaultMessage: 'in 3 weeks',
  },
  months: {
    id: 'UserCase.heading',
    defaultMessage: 'in 6 months',
  },
  marianneName: {
    id: 'UserCase.name',
    defaultMessage: 'Marianne',
  },
  marianneQuote: {
    id: 'UserCase.quote',
    defaultMessage:
      'The best thing about Lifesum is the full overview you get on your nutrition. I’ve learnt how to prioritize my food which makes me even more motivated to continue my journey. I’ve tried other similar apps before, but Lifesum is really easy to use and stick to.',
  },
  nikeQuote: {
    id: 'Kickstarter.userQuote',
    defaultMessage:
      'I’ve learned that dieting doesn’t have to be difficult, and was really surprised I was allowed to eat tasty things like sandwiches and dressings! The food was delicious, easy to cook, and you even get a shopping list. This program was so easy to follow, and my cravings were gone after only a few days!',
  },
  nathalieQuote: {
    id: 'homepage_user_quote',
    defaultMessage:
      'This app is like the best thing that has happened to my health. I was shocked how my cravings were gone after only a couple of days and not wanting to eat between meals really helped. Losing 5kg in only 3 weeks is fantastic, but the best part is the health improvement. I feel remarkably much better, have more energy, better mood, can play with my kids and do more than ever.',
  },
})
